// src/services/api.js
import axios from "axios";

// Log the base URL for debugging
console.log("🌐 API Base URL:", process.env.REACT_APP_API_BASE_URL);

// Create axios instance with final correct base URL
const API = axios.create({
  baseURL:
  (process.env.REACT_APP_API_BASE_URL || "https://clothconnect-backend-hsb1.onrender.com/api"),
});
// Log all API requests
API.interceptors.request.use((config) => {
  console.log(
    `[API Request → ${config.method.toUpperCase()}]`,
    config.baseURL + config.url,
    config.data || ""
  );
  return config;
});

// Log API errors
API.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("❌ Response Error:", error.response || error.message);
    return Promise.reject(error);
  }
);

export default API;
